import { IConfiguredHttp } from './http';

export interface IFXApi {
	getFXRateOnDate: (fromCurrency: string, toCurrency: string, onDate?: string) => Promise<number>;
}

const fxApiFactory = (http: IConfiguredHttp, prefix = ''): IFXApi => ({
	getFXRateOnDate(fromCurrency, toCurrency, onDate) {
		if (!onDate) {
			return http.get(`${prefix}/rate/from/${fromCurrency}/to/${toCurrency}`);
		}
		return http.get(`${prefix}/rate/from/${fromCurrency}/to/${toCurrency}?on_date=${onDate}`);
	}
});

export default fxApiFactory;
